import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/$id/general")({
  staticData: {
    title: "common.general",
  },
});
